/**
 * The name of the pinned cache, shared by the page that writes it and the
 * service worker that reads it.
 *
 * Its own module because the worker must not pull in the app's API client to
 * learn one string, and because a typo here would not fail a build — it would
 * fail an evacuation, quietly, months later.
 */
export const EMERGENCY_CACHE = 'libretto42-player-emergency';

/** A media URL without its presigned signature, which rotates hourly. */
export function withoutQuery(url: string): string {
  const cut = url.indexOf('?');
  return cut === -1 ? url : url.slice(0, cut);
}
